export * from './ActorRdfMetadataExtractSparqlService';
